//
// Shared/global constants for use throughout the app
//

/**
 * A map of helper methods to build the URI suffix needed to
 * make a specific API call.
 *
 * Also makes a single convenient place to update any URI
 * should it change in the future.
 */
export const API_URLS = {
  // HTTP GET
  getRecentActivity: "/imports/",
  getEProtocolActivity: (startDate, endDate) =>
    `/eprotocol/activity?start=${startDate}&end=${endDate}`,

  // HTTP POST
  importParticipantRegistration: (instance) =>
    `/imports/participant-registration?instance=${instance}`,
  importTrainingData: (instance) =>
    `/imports/training-data?instance=${instance}`,
  jsonPlaceholder: (csvType) =>
    `https://jsonplaceholder.typicode.com/posts/${csvType}`,
};

/**
 * Static names for general API response types.
 *
 * (i.e. success, failure, warning)
 */
export const API_STATUS = {
  API_WARN: "API_WARN",
  API_ERROR: "API_ERROR",
  API_SUCCESS: "API_SUCCESS",
};

/**
 * Browser Storage API names
 */
export const STORAGE_TYPE = {
  LOCAL: "localStorage",
  SESSION: "sessionStorage",
};

/**
 * TimeZone
 */
export const TIME_ZONE = {
  PST: "America/Los_Angeles",
};
